//
// The Frontend JS
//
var iFrameResize = require('iframe-resizer/js/iframeResizer.min');
var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var Clipboard       = require('./common/clipboard');
var Tooltips        = require('./common/tooltips');
var Filters         = require('./common/forms/filters');
var Bump            = require('./common/bump');
var Analytics       = require('./plugin/analytics');

iFrameResize({
    warningTimeout: 0,
    resizedCallback: function() {
        $(window).trigger('resize');
    }
}, '.donate-widget__frame');

Clipboard.init();
Tooltips.init();
Filters.init();
Bump.init();
